import React from 'react';
import { useSelector } from 'react-redux';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import OfferTableMobileContent from './OfferTableItemMobileContent';
import OfferTableDesktopContent from './OfferTableItemDesktopContent';

function OfferTableItem({ dataItem, sectionId, rebateOptions }) {
  const isMobileMQ = useSelector(selectIsMobileMQ);

  return isMobileMQ
    ? <OfferTableMobileContent dataItem={dataItem} sectionId={sectionId} rebateOptions={rebateOptions} />
    : <OfferTableDesktopContent dataItem={dataItem} sectionId={sectionId} rebateOptions={rebateOptions} />;
}

export default (props) => <ComponentErrorBoundary><OfferTableItem {...props} /></ComponentErrorBoundary>;
